import React from "react";
import { storyblokEditable } from "gatsby-source-storyblok";
import { ProcessLink } from "../../global/helpers"
 
const Button = ({blok}) => {
  if(blok !== undefined){
    const ButtonHTML = ({button}) => {
      const link = ProcessLink(button.content_target);
      switch(button.Style){
        case 'tertiary': 
          return ( 
            <>  
              <a key={button.id} href={link.url} target={link.target} rel={link.rel} title={link.title} className={"button " + button.Style + " " + link.cssClass}>
                <span>{button.Label}</span>
                <span className="hover">{button.Label}</span>
              </a> 
              <Modal link={link} />
            </>
          )
        case 'mobileHeader':
          return (
            <>
              <span>{button.Label}</span>
              <a key={button.id} href={link.url} target={link.target} rel={link.rel} title={link.title} aria-label={link.title} className="button primary">
                <span className="arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" height={27} fill="currentColor"><path d="M233 239c9.4 9.4 9.4 24.6 0 33.9L73 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L39 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L233 239z"/></svg>
                </span>
              </a>
              <Modal link={link} />
            </>
          )
        case 'cta_bar':
          return (
            <>
              <div className="cta-bar gs_reveal">
                <span className="cta-bar__title">{button.Label}</span>
                <a key={button.id} href={link.url} target={link.target} rel={link.rel} title={link.title} aria-label={link.title} className="button secondary">
                  <span className="arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" height={27} fill="currentColor"><path d="M233 239c9.4 9.4 9.4 24.6 0 33.9L73 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L39 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L233 239z"/></svg>
                  </span>
                  <div className='btn-bg top'></div>
                  <div className='btn-bg bottom'></div>
                </a>
              </div>
              <Modal link={link} />
            </>
          )
        default:
          return (
            <>
              <a 
              key={button.id} 
              href={link.url} 
              data-fancybox={link.dataFancybox} 
              data-src={typeof link.modalId !== undefined ? "#" + link.modalId : null}
              target={link.target} 
              rel={link.rel} 
              title={link.title}
              className={"button " + button.Style + " " + link.cssClass}>
                <span>{button.Label}</span>
                <div className='btn-bg top'></div>
                <div className='btn-bg bottom'></div>
              </a>
              <Modal link={link} />
            </>
          );
      }
    }

    const Modal = ({link}) => {
      if(typeof link.modal !== 'undefined'){
        return link.modal
      }else{
        return false;
      }
    }

    const ButtonLoop = ({blok}) => {
      if(blok.length > 0){ 
        return blok.map(button => <ButtonHTML key={button._uid} button={button} />);
      }else{
        return (
          <ButtonHTML button={blok} />         
        );
      }
    }

    return(
      <div {...storyblokEditable(blok)} key={blok._uid} className={((typeof blok.position_horizontal !== 'undefined') ? "cta_container "+blok.position_horizontal : "cta_container") + " component"}>
        <ButtonLoop blok={blok} />
      </div>
    )
  }else{
    return false
  }
}
 
export default Button;
